import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Unstable_Grid2';

import moment from 'moment';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Seo } from 'src/components/seo';
import { useSettings } from 'src/hooks/use-settings';
import { useStopwatch } from 'src/layouts/check-in-checkout/StopwatchContext';
import {
  getAllDocumentationOverview,
  getAllTaskOverview,
  getAllTherapyOverview,
  getTimeCheckInAction,
} from 'src/redux/actions/therapist-dashboard-action';
import ThoughtSpotIntegration from 'src/sections/department-dashboard/ThoughtspotIntegration';
import {
  convertDateToFacilityDate,
  convertIntoIsoFormat,
} from 'src/utils/convertDateToSelectedTimeZone';
import DocumentManagement from './therapist-document/document-manegment';
import TimeInTimeOut from './time-in-out/time-in-time-out';
import TodaysOverview from './todays-activity/todays-overview';
// import { convertDateToFacilityDate } from 'src/utils/convertDateToSelectedTimeZone';
import { Alert, Card, Chip, Snackbar } from '@mui/material';
import useCurrentUser from 'src/hooks/use-current-user';
import { TaskStatus } from './task-overview/task-status';
import { NewUpdates } from './new-updates';
import NewSlickSlider from './new-slider';
const now = new Date();

const Page = () => {
  const settings = useSettings();
  const dispatch = useDispatch();
  const { isRunning } = useStopwatch();
  let realm = '';
  if (window.location.hostname === 'localhost') {
    realm = localStorage.getItem('realm') || '';
  } else {
    realm = window.location.hostname.split('-')[0] || '';
  }
  const [providerId] = useCurrentUser(['providerId']);
  // const user = useSelector((state: any) => state.getTherapistProfileReducer?.response?.data);
  // const [greeting, setGreeting] = useState('');
  // const therapistLoginResponse = useSelector((state: any) => state.therapistLoginReducer);
  const facilityId = localStorage.getItem('facilityId');
  // useEffect(() => {
  //   const updateGreeting = () => {
  //     const currentHour = new Date().getHours();

  //     if (currentHour >= 5 && currentHour < 12) {
  //       setGreeting('Good Morning');
  //     } else if (currentHour >= 12 && currentHour < 17) {
  //       setGreeting('Good Afternoon');
  //     } else {
  //       setGreeting('Good Evening');
  //     }
  //   };

  //   updateGreeting();

  //   const intervalId = setInterval(updateGreeting, 60000);

  //   return () => clearInterval(intervalId);
  // }, []);

  useEffect(() => {
    const currentDate = new Date();
    const dateTimeAccordingToFacility = convertDateToFacilityDate(currentDate);
    const getFacilityTimeZone = localStorage.getItem('facility_timezone') || '';
    const formattedDate = moment(currentDate).format('YYYY-MM-DD');
    if (providerId) {
      // dispatch(
      //   getTherapistDashboardPatientList({
      //     providerId,
      //     date: formattedDate,
      //   })
      // );
      dispatch(
        getAllTaskOverview({
          providerId,
          date: formattedDate,
          facilityId,
        })
      );
      dispatch(
        getAllTherapyOverview({
          providerId,
          date: formattedDate,
          facilityId,
        })
      );
      dispatch(
        getAllDocumentationOverview({
          providerId,
          date: formattedDate,
          facilityId,
        })
      );
      if (!isRunning) {
        dispatch(
          getTimeCheckInAction({
            providerId,
            date: convertIntoIsoFormat(dateTimeAccordingToFacility),
            zoneTime: getFacilityTimeZone,
          })
        );
      }

      // dispatch(
      //   getLatestPtoUpdates({
      //     providerId,
      //   })
      // );
    }
  }, [providerId]);

  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [snackBarMsg, setSnackBarMsg] = useState('');

  const getResponseOfCheckout = useSelector((state: any) => state.checkoutReducer);

  useEffect(() => {
    if (getResponseOfCheckout?.isGetCheckIn === false && getResponseOfCheckout?.response !== null) {
      setSnackBarMsg(getResponseOfCheckout?.response?.message);
      setOpenSnackBar(true);

      return;
    }
  }, [getResponseOfCheckout]);

  const handleCloseSnackBar = () => {
    setSnackBarMsg('');
    setOpenSnackBar(false);
  };

  const therapistDailyUpdatesCount = useSelector(
    (state: any) => state.therapistDailyUpdatesReducer.response?.data?.length
  );
  return (
    <>
      <Seo title="Restore-Insights: Dashboard" />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          // py: 8,
          py: 3,
        }}
      >
        <Container maxWidth={settings.stretch ? false : 'xl'}>
          <Grid
            container
            disableEqualOverflow
            spacing={{
              xs: 3,
              lg: 4,
            }}
          >
            <Grid xs={12}>
              <Stack
                direction="row"
                justifyContent="space-between"
                spacing={4}
              >
                <div
                  style={{ display: 'flex', flexDirection: 'column', width: '100%', gap: '8px' }}
                >
                  <Typography variant="h4">
                    My Day
                    {/* {greeting || ''}, {user?.firstName || ''} */}
                  </Typography>
                  <Typography
                    sx={{ color: '#6C737F' }}
                    variant="body2"
                  >
                    Manage your goals, tasks and activities for today
                  </Typography>
                </div>

                <TimeInTimeOut />
              </Stack>
            </Grid>
            <Grid
              xs={12}
              md={12}
              container
              mb={'30px'}
            >
              <Grid
                md={12}
                lg={4.5}
              >
                <Box
                  display={'flex'}
                  alignItems={'center'}
                  gap={'10px'}
                  mb={'10px'}
                >
                  <Typography variant="h6">Daily Updates</Typography>
                  <Chip
                    label={`${therapistDailyUpdatesCount} Updates`}
                    variant="outlined"
                    sx={{ height: '25px', marginLeft: '5px', border: '1px solid #afb3ba9e' }}
                  />
                </Box>
                <Box
                  sx={{
                    height: '280px',
                    borderRadius: '18px',
                    boxShadow: '0px 0px 6px rgba(0, 0, 0, 0.1)',
                    overflow: 'hidden',
                  }}
                >
                  <NewSlickSlider />
                </Box>
              </Grid>
              <Grid
                md={12}
                lg={7.5}
              >
                <Typography
                  variant="h6"
                  mb={'10px'}
                >
                  Daily Overview
                </Typography>
                <TaskStatus />
              </Grid>
            </Grid>

            <Grid xs={12}>
              <TodaysOverview />
            </Grid>

            <Grid
              xs={12}
              md={12}
            >
              <DocumentManagement />
            </Grid>
            {/* <Grid
              xs={12}
              md={4}
            >
              <AcademyDailyProgress />
            </Grid> */}
          </Grid>
          <Grid
            style={{ marginTop: '20px', marginBottom: '20px' }}
            xs={12}
            md={12}
          >
            {/* <NewUpdates /> */}
            {/* <AcademyDailyProgress /> */}
            {realm && (
              <ThoughtSpotIntegration
                who="therapist"
                realm={realm}
              />
            )}
          </Grid>
        </Container>
        <Snackbar
          onClose={handleCloseSnackBar}
          autoHideDuration={2000}
          open={openSnackBar}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >
          <Alert
            onClose={handleCloseSnackBar}
            severity="error"
            variant="filled"
            sx={{ width: '100%' }}
          >
            {snackBarMsg}
          </Alert>
        </Snackbar>
      </Box>
    </>
  );
};

export default Page;
